<template>
  <div id="app">
    <div class="container">
      <div class="img">
        <img src="./assets/background2.png" v-if="adId === 'bilibbj'">
        <img src="./assets/background.png" v-else-if="adId === 'biligc'">
        <img src="./assets/genshin_background.png" v-else>
      </div>
      <div class="download" v-if="isShowDownload">
        <span @click="downLoad()">下载</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      adId: 'bilibbj',
      baseUrl: 'https://api.xiaoheihe.cn/',
      isShowDownload: true
    }
  },
  methods: {
    getDevicetype () {
      var userAgentInfo = navigator.userAgent;
      var isAndroid = userAgentInfo.indexOf('Android') > -1 || userAgentInfo.indexOf('Adr') > -1;//android终端
      if(isAndroid){
          return 'Android'
      }
      var isiOS = !!userAgentInfo.match(/Mac OS X/); //ios终端
      if(isiOS){
          return 'iOS'
      }
      return 'unkown'
    },
    downLoad () {
      let device = this.getDevicetype()
      const url = this.baseUrl + '/heybox/open/ad_serving/report'
      const params = {
        ad_id: this.adId,
        event: 'download',
        ad_os_type: device
      }
      this.$http.get(url, {params}).then(res => {
        let a = document.createElement('a')
        if (device === 'iOS') {
          window.location.href = 'https://apps.apple.com/cn/app/id1244505010'
          // a.href = 'https://apps.apple.com/cn/app/id1244505010'
          // a.click()
        } else {
          if (this.adId === 'bilibbj') {
            a.href = 'https://cdn.max-c.com/app/heybox/heybox-heybox_bili_up_bbj.apk'
            a.click()
          } else {
            a.href = 'https://cdn.max-c.com/app/heybox/heybox-heybox_bili_up_gamecompass.apk'
            a.click()
          }
        }
      })
    },
    //yuanshen
    downGenshinLoad () {
      let device = this.getDevicetype()
      const url = this.baseUrl + '/heybox/open/ad_serving/report'
      const params = {
        ad_id: this.adId,
        event: 'download',
        ad_os_type: device
      }
      this.$http.get(url, {params}).then(res => {
        let a = document.createElement('a')
        if (device === 'iOS') {
          window.location.href = 'https://apps.apple.com/cn/app/id1244505010'
        } else {
          a.href = 'https://dl.max-c.com/app/heybox/heybox-heybox_refer_yuanshen_card_nopage.apk'
          a.click()
        }
      })
    },
    point () {
      let device = this.getDevicetype()
      const url = this.baseUrl + '/heybox/open/ad_serving/report'
      const params = {
        ad_id: this.adId,
        event: 'enter',
        ad_os_type: device
      }
      this.$http.get(url, {params}).then(res => {
      })
    },
    resolveParams () {
      var search = location.search.slice(1).split('&')
			var app = {}
			for (var i=0; i<search.length; i++) {
				var query = search[i].split('=')
				if (!app[query[0]]) {
					app[query[0]] = query[1]
				}
			}
      if (app.ad_id) {
        this.adId = app.ad_id 
      }
      if (this.adId === 'refer_yuanshen_card_nopage') {
        this.isShowDownload = false
      }
      this.point()
      if (this.isShowDownload === false) {
        this.downGenshinLoad()
      }
    },
  },
  created () {
    this.resolveParams()
  }
}
</script>

<style scoped>
#app {
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  
}
body, html {
  margin: 0;
  padding: 0;
}
.container {
  position: relative;
  height: 100%;
}
.img {
  width: 100%;
  height: 100%;
}
img {
  width: 100%;
  height: 100%;
}
.container .download {
  position: fixed;
  z-index: 999;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.container .download span {
  display: inline-block;
  width: 80px;
  height: 35px;
  border-radius: 8px;
  opacity: 0.8;
  line-height: 35px;
  background-color: black;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue